export type ProjectRole = { project_id: string; role: string };

export function getProjectRoles(): ProjectRole[] {
  try {
    return JSON.parse(localStorage.getItem("project_roles") || "[]");
  } catch {
    return [];
  }
}

export function getGlobalRole(): string {
  return localStorage.getItem("role") || "viewer";
}

export function isSuperAdmin(): boolean {
  return getGlobalRole() === "super_admin";
}

export function isGlobalAdmin(): boolean {
  return getGlobalRole() === "admin";
}

export function isGlobalEditor(): boolean {
  return getGlobalRole() === "editor";
}

export function isGlobalViewer(): boolean {
  return getGlobalRole() === "viewer";
}

export function canCreateProject(): boolean {
  return isSuperAdmin() || isGlobalAdmin();
}

export function canManageUsers(): boolean {
  return isSuperAdmin();
}

export function canSeeUserManagement(): boolean {
  return isSuperAdmin() || isProjectAdminAnywhere();
}

export function isProjectAdminAnywhere(): boolean {
  if (isSuperAdmin()) return true;
  return getProjectRoles().some((p) => p.role === "admin");
}

export function getAdminProjectIds(): string[] {
  if (isSuperAdmin()) return [];
  return getProjectRoles().filter((p) => p.role === "admin").map((p) => p.project_id);
}

export function isProjectAdmin(projectId: string | undefined): boolean {
  if (!projectId) return false;
  if (isSuperAdmin()) return true;
  return getProjectRoles().some((p) => p.project_id === projectId && p.role === "admin");
}

export function isProjectMember(projectId: string | undefined): boolean {
  if (!projectId) return false;
  if (isSuperAdmin() || isGlobalAdmin() || isGlobalEditor()) return true;
  return getProjectRoles().some((p) => p.project_id === projectId);
}

export function getProjectRole(projectId: string | undefined): string | null {
  if (!projectId) return null;
  if (isSuperAdmin()) return "super_admin";
  if (isGlobalAdmin()) return "admin";
  if (isGlobalEditor()) return "editor";
  const found = getProjectRoles().find((p) => p.project_id === projectId);
  return found ? found.role : null;
}

export function isViewerOnly(): boolean {
  return isGlobalViewer() && getProjectRoles().length === 0;
}
